import {
  setDebug,
  init as initSDK,
  viewport,
  emitEvent,
  mockTelegramEnv,
  swipeBehavior,
  ThemeParams,
  retrieveLaunchParams,
  themeParams,
  backButton,
  initData,
  miniApp,
} from '@tma.js/sdk-react';

// Флаг для предотвращения повторных редиректов
let redirectHandled = false;

/**
 * Initializes the application and configures its dependencies.
 */
export async function init(options: { debug: boolean }): Promise<void> {
  // Set @telegram-apps/sdk-react debug mode and initialize it.
  setDebug(options.debug);
  initSDK();

  let firstThemeSent = false;
  mockTelegramEnv({
    onEvent(event, next) {
      if (event.name === 'web_app_request_theme') {
        let tp: Partial<ThemeParams> = {};
        if (firstThemeSent) {
          const state = themeParams.state;
          tp = state as Partial<ThemeParams>;
        } else {
          firstThemeSent = true;
          const lp = retrieveLaunchParams();
          tp = (lp.tgWebAppThemeParams || {}) as Partial<ThemeParams>;
        }
        return emitEvent('theme_changed', { theme_params: tp as any });
      }

      if (event.name === 'web_app_request_safe_area') {
        return emitEvent('safe_area_changed', {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
        });
      }

      try {
        next();
      } catch (error) {
        console.error('Error in mockTelegramEnv onEvent handler:', error);
      }
    },
  });

  // Handle redirect based on startParam - выполняется только один раз
  if (!redirectHandled) {
    try {
      const launchParams = retrieveLaunchParams();
      const startParam = launchParams?.tgWebAppStartParam;

      if (startParam?.startsWith('u_') && typeof window !== 'undefined') {
        // Проверяем, не находимся ли мы уже на целевой странице
        const currentPath = window.location.pathname;
        const userId = startParam.replace('u_', '');
        const targetPath = `/user/${userId}`;

        if (currentPath !== targetPath) {
          console.log('Redirecting to user profile:', userId);

          // Устанавливаем флаг перед редиректом
          redirectHandled = true;

          // Сохраняем флаг в sessionStorage для предотвращения повторных редиректов
          sessionStorage.setItem('redirectHandled', 'true');

          // Clear the start param from URL
          const url = new URL(window.location.href);
          url.searchParams.delete('tgWebAppStartParam');
          window.history.replaceState({}, '', url.toString());

          // Perform redirect
          window.location.href = targetPath;
          return; // Exit early
        } else {
          console.log('Already on target page, skipping redirect');
          redirectHandled = true;
        }
      }
    } catch (error) {
      console.warn('Failed to handle start param redirect:', error);
    }
  }

  // Проверяем sessionStorage для предотвращения повторных редиректов после перезагрузки
  if (typeof window !== 'undefined') {
    const stored = sessionStorage.getItem('redirectHandled');
    if (stored) {
      redirectHandled = true;
    }

    // Очищаем флаг при новом запуске приложения (опционально)
    // sessionStorage.removeItem('redirectHandled');
  }

  // Mount all components used in the project.
  backButton.mount();
  initData.restore();

  try {
    miniApp.mount();
    themeParams.bindCssVars();
  } catch (e) {
    // miniApp not available
  }

  await viewport.mount().catch((error) => {
    console.error('Failed to mount viewport:', error);
  });

  if (viewport.expand.isAvailable()) {
    viewport.expand();
  }

  if (viewport.requestFullscreen.isAvailable()) {
    await viewport.requestFullscreen().catch((error) => {
      console.error('Failed to request fullscreen:', error);
    });
  }

  viewport.mount().then(() => {
    viewport.bindCssVars();
  });

  swipeBehavior.mount();
  swipeBehavior.disableVertical();
}
